"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const styles = (0, _makeStyles.default)(theme => ({
  intro: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(6)
  },
  buttons: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    justifyContent: "center",
    "& > div": {
      margin: "0 auto",
      [theme.breakpoints.up("sm")]: {
        margin: 0
      }
    },
    [theme.breakpoints.up("sm")]: {
      flexDirection: "row",
      justifyContent: "flex-start"
    }
  },
  headline: {
    marginBottom: theme.spacing(4)
  },
  actionWrapper: {
    background: theme.palette.background.light ? theme.palette.background.light : "F8F8F8",
    padding: theme.spacing(3),
    "& > div": {
      display: "flex",
      flexDirection: "column",
      flexWrap: "wrap",
      gap: theme.spacing(1),
      width: "100%",
      [theme.breakpoints.up("sm")]: {
        display: "grid",
        gridTemplateColumns: "1fr 1fr"
      },
      [theme.breakpoints.up("lg")]: {
        gap: theme.spacing(3)
      }
    },
    "& > span": {
      display: "block",
      marginTop: theme.spacing(3)
    },
    [theme.breakpoints.up("md")]: {
      padding: theme.spacing(6)
    }
  },
  item: {
    alignItems: "center",
    background: theme.palette.common.white,
    cursor: "pointer",
    userSelect: "none",
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(0.5),
    justifyContent: "center",
    padding: theme.spacing(3),
    textAlign: "center",
    transition: "all 150ms ease",
    [theme.breakpoints.up("sm")]: {
      padding: theme.spacing(5)
    },
    [theme.breakpoints.up("md")]: {
      minHeight: 160
    },
    "& p": {
      margin: 0
    },
    "& svg path": {
      transition: "fill 150ms ease"
    },
    "&:hover": {
      background: theme.palette.primary.main,
      color: theme.palette.common.white,
      "& svg path": {
        fill: theme.palette.common.white
      }
    }
  },
  overlay: {
    "& .mco-datepicker-header": {
      paddingLeft: "0 !important",
      paddingRight: "0 !important"
    },
    "& .mco-overlay-scroll": {
      padding: "40px 16px !important"
    },
    "& .mco-datepicker-weekdays__day": {
      fontSize: "14px !important"
    },
    "& .mco-datepicker-day": {
      fontSize: "14px !important"
    },
    "& .mco-datepicker-day--is-saturday": {
      background: "#F2F2F2 !important"
    },
    "& .mco-datepicker-header__arrow-next-month, & .mco-datepicker-header__arrow-previous-month": {
      background: "#F2F2F2 !important",
      "& svg": {
        width: "20px !important"
      }
    }
  }
}));
var _default = exports.default = styles;